import { render } from "./StatsAndFinanceCard.vue?vue&type=template&id=64138d65"
import script from "./StatsAndFinanceCard.vue?vue&type=script&lang=js"
export * from "./StatsAndFinanceCard.vue?vue&type=script&lang=js"

import "./StatsAndFinanceCard.vue?vue&type=style&index=0&id=64138d65&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__